export enum UniLinkSize {
  large = 'large',
  medium = 'medium',
  small = 'small',
}
